export interface Permission {
  name: string;
  url: string;
  description?: string;
  marked?: boolean;
  groupName?: string;
}

export interface PermissionGroup {
  id: number;
  name: string;
  description: string;
  permissions: Permission[];
}

export enum PermissionUserStatus {
  Normal = 'normal',
  Removed = 'removed'
}

export interface PermissionUser {
  username: string;
  email: string;
  name: string;
  roles: string;
  lastLoginDate: string;
  creationDate: string;
  modificationDate: string;
  status: PermissionUserStatus;
  plainPassword: string;
}

export enum PermissionRoleStatus {
  Normal = 'normal',
  Removed = 'removed'
}

export interface PermissionRole {
  roleName: string;
  description: string;
  permissionCount: number;
  userCount: number;
  marked?: boolean;
  status: PermissionRoleStatus;
}
